import { render, staticRenderFns } from "./partnerHeader.vue?vue&type=template&id=d7120ffe&scoped=true&v-if=lang%20%26%26%20__(title)&"
import script from "./partnerHeader.vue?vue&type=script&lang=js&"
export * from "./partnerHeader.vue?vue&type=script&lang=js&"
import style0 from "./partnerHeader.scss?vue&type=style&index=0&id=d7120ffe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7120ffe",
  null
  
)

export default component.exports